import parseHttpAction from './parseHttpAction';
import CustomHttpAction from '../cardActions/CustomHttpAction';
import { Action, HttpAction } from 'adaptivecards';
import { CardDetails } from 'owa-actionable-message-v2';
import { HTTP_POST } from './adaptiveCardActionTypes';

export default function processAutoInvokeAction(
    actionDefinition: any,
    cardDetails: CardDetails
): Action {
    if (
        actionDefinition.type === HttpAction.JsonTypeName ||
        actionDefinition['@type'] === HTTP_POST
    ) {
        let action: HttpAction;
        // If the card is not an adaptive card parse it using the special parseHttpAction helper function that converts message
        // card actions into adaptive card actions. If it is an adaptive card, parse the action normally as a CustomHttpAction
        if (!cardDetails.isAdaptiveCard) {
            action = parseHttpAction(actionDefinition);
        } else {
            action = new CustomHttpAction(false);
            action.parse(actionDefinition);
            (action as CustomHttpAction).hideCardOnInvoke = actionDefinition.hideCardOnInvoke;
        }
        return action;
    }

    return null;
}
